import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10010View from "../../Views/Bases/BM10010";
import Snackbar from "../../Components/Snackbar";

function BM10010(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({
    groupCode: "",
    code: "",
    result: false,
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10010.BM10010
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            code: data[i].code,
            name: data[i].name,
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            createId: data[i].createId,
            groupCd: data[i].groupCd,
            ref1: data[i].ref1,
            ref2: data[i].ref2,
            ref3: data[i].ref3,
            sortSeq: data[i].sortSeq,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
            val1: data[i].val1,
            val2: data[i].val2,
            val3: data[i].val3,
          });
        }
      });

      setRowData(getRowData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckKeys = async () => {
    Dialog.ProgressBar(true);

    if (checkInputs.groupCode === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_CheckGroupCode" && f.lanType === "SNACK"
        )[0].lanName,
      });
      Dialog.ProgressBar(false);
      return;
    } else if (checkInputs.code === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_CheckCode" && f.lanType === "SNACK"
        )[0].lanName,
      });
      setCheckInputs({
        ...checkInputs,
        groupCode: "",
      });
      Dialog.ProgressBar(false);
      return;
    }

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10010.CheckCode,
        {
          groupCd: checkInputs.groupCode,
          code: checkInputs.code,
        }
      ).then((result) => {
        let data = result.data;

        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            groupCode: "",
            code: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let tranData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10010.Create,
        updateData.length === 0 ? saveData : updateData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let tranData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < selectedRowData.length; i++) {
        tranData.push({
          groupCd: selectedRowData[i].groupCd,
          code: selectedRowData[i].code,
          val1: selectedRowData[i].val1,
          Val2: selectedRowData[i].Val2,
          Val3: selectedRowData[i].Val3,
          ref1: selectedRowData[i].ref1,
          ref2: selectedRowData[i].ref2,
          ref3: selectedRowData[i].ref3,
          sortSeq: selectedRowData[i].sortSeq,
          createId: userInfo.userId,
          createDate: new Date(),
          updateId: userInfo.userId,
          updateDate: new Date(),
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10010.Delete,
        tranData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Bm10010View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        CheckKeys={CheckKeys}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10010;
